export const GET_TEMPLATE_LIST = "template/getTemplateList";
export const CREATE_TEMPLATE = "template/createTemplate";
export const UPDATE_TEMPLATE = "template/updateTemplate";
export const REMOVE_TEMPLATE = "template/removeTemplate";
export const GET_ACTIVE_TEMPLATE = "template/getActiveTemplate";
